import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import ResetPasswordPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { registerState } from '../../../../common/Services/RegistrationService.js';
import ResetPasswordPanelActions from './redux/actions';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'resetPasswordPanel';
import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createResetPasswordScreen = ({ userId, userEmail, userRoles }) => {
  const domId = 'resetPasswordPanel';
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    const isSupportUser = userRoles.filter(role => -1 !== ['ROLE_ROOT', 'ROLE_SUPPORT'].indexOf(role)).length >= 1;
    store.dispatch(ResetPasswordPanelActions.bootstrap(userId, userEmail, isSupportUser));

    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <ResetPasswordPanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createResetPasswordScreen = createResetPasswordScreen;
export { namespace };
